// Cache-busting version for static assets under /assets/* (stable filenames that
// Caddy serves as immutable — see config.js / deploy.yml). Kept in its own module so
// it stays importable from plain Node (unit tests) without pulling in config.js, which
// touches `import.meta.env`/`location` at load. The `typeof` guard keeps Vite's literal
// `import.meta.env.VITE_ASSET_VERSION` replacement intact while not crashing under Node.
export const ASSET_VERSION =
  (typeof import.meta.env !== 'undefined' && import.meta.env.VITE_ASSET_VERSION) || 'dev';

// Append the version query to an asset URL: assetUrl('/assets/scenes/bg_street.webp').
export function assetUrl(path) {
  return `${path}?v=${ASSET_VERSION}`;
}
